import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import PropTypes from 'prop-types';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';

import Header from "../../components/Header/Header.jsx";
import HeaderLinks from "../../components/Header/HeaderLinks.jsx";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Parallax from "../../components/Parallax/Parallax.jsx";

import SectionCatalog from "./Sections/SectionCatalog";
import FooterSection from "../LandingPage/Sections/FooterSection";

import accommodationsPageStyle from "../../assets/jss/material-kit-pro-react/views/accommodationsStyle";

import { getAccommodations } from '../../actions/accommodationsActions';

import headerImg from "../../assets/img/landing-bg.jpg";
import Spinner from '../../components/common/Spinner';

class AccommodationsPage extends React.Component {
    componentDidMount() {
        this.props.getAccommodations();

        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    }

    render() {
        const { classes, accommodation } = this.props;
        const { loading } = accommodation;

        let productsSection;

        if (accommodation.accommodations.length===0 || loading) {
            productsSection = <Spinner />;
        } else {
            productsSection = <SectionCatalog accommodations={accommodation.accommodations} />;
        }

        return (
            <div>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Alojamientos | Vivamos el Campo - Turismo Rural</title>
                    <link rel="canonical" href="https://vivamoselcampo.co/accommodations" />
                    <meta name="description" content="Explora Alojamientos y Hospedajes, escoge el que más se adapte a tus gustos y a tu bolsillo" />
                </Helmet>

                <Header
                    fixed
                    brand="Vivamos el Campo Logo"
                    color="transparent"
                    links={<HeaderLinks dropdownHoverColor="info"/>}
                    changeColorOnScroll={{
                        height: 180,
                        color: "white"
                    }}
                />
                <Parallax
                    image={headerImg}
                    filter="dark"
                    small
                >
                    <div className={classes.container}>
                        <GridContainer>
                            <GridItem md={8} sm={8} className={classNames( classes.mlAuto, classes.mrAuto, classes.textCenter )}>
                                <div className={classes.brand}>
                                    <h1 className={classes.title}>Alojamientos Rurales</h1>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>

                    {productsSection}

                    <FooterSection />
                </div>
            </div>
        );
    }
}

AccommodationsPage.propTypes = {
    getAccommodations: PropTypes.func.isRequired,
    accommodation: PropTypes.object,
    filtersReducer: PropTypes.object
};

const mapStateToProps = state => ({
    accommodation: state.accommodation,
    filtersReducer: state.filtersReducer
});

export default connect(mapStateToProps, { getAccommodations })( withStyles(accommodationsPageStyle)(AccommodationsPage) );


// WEBPACK FOOTER //
// ./src/views/AccommodationsPage/AccommodationsPage.jsx